import coverImageMilk from "../../../assets/images/milk/milkCategoryCoverImage.webp";
import milkCategoryCoverImageMobile from '../../../assets/images/milk/milkCategoryCoverImageMobile.webp'
import milkImage1 from '../../../assets/images/milk/milkImage1.webp'

export const MilkProductsArrRu = [
    {
        path: "/ru/milk/milk-ukrainian-2-5-fat-mumulya-900g/",
        category: "milk",
        metaTitle: "Молоко Мумуля",
        metaDescription: "Молоко питьевое пастеризованное «Украинское» 2,5 % жира ТМ «МУМУЛЯ» 900 g (г)",
        coverImage: coverImageMilk,
        coverImageMobile: milkCategoryCoverImageMobile,
        coverTitle: "Молоко Пастеризованное",
        aboutImage: milkImage1,
        aboutTitle: "Молоко питьевое пастеризованное «Украинское» 2,5 % жира ТМ «МУМУЛЯ» 900 g (г)",
        aboutStats: [
            "3,0 g (г)", "2,5 g (г)", "4,5 g (г)", "57 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Масса/Объём:",
                desc: "900 g (г)",
            },
            {
                title: "Упаковка:",
                desc: "Плёнка",
            },
            {
                title: "Состав:",
                desc: "молоко коровье цельное, молоко коровье обезжиренное.",
            },
            {
                title: "Срок годности:",
                desc: "Хранить при температуре (4±2)°C не более 7 суток с даты производства.",
            },
            {
                title: "Сертификат качества:",
                desc: "ТУ У 25027034-008-98",
            },
        ],
        categoryInfo: [
            "Тщательный контроль сырого молока и фермерских хозяйств.",
            "Бактериологическая чистота молока  - результат пастеризации и термической обработки, а также соблюдения санитарных норм.",
            "Чистый натуральный молочный вкус коровьего молока.",
        ]
    },
]